import { requireExhaustive } from "../../shared/src/util";
import * as InternalScope from "../../domain/models/InternalScope";

export type T = "web" | "api";

export const getDomainNameFromEnv = (p: T): string =>
    p === "web" ? env.REACT_APP_ROOT_DOMAIN || ""
    : p === "api" ? process.env.DOMAIN_NAME || ""
    : requireExhaustive(p);

export const getSailLegalDomainNameFromEnv = (p: T): string =>
    p === "web" ? env.REACT_APP_SAIL_LEGAL_DOMAIN_NAME || ""
    : p === "api" ? process.env.SAIL_LEGAL_DOMAIN_NAME || ""
    : requireExhaustive(p);

export const getSailProbateDomainNameFromEnv = (p: T): string =>
    p === "web" ? env.REACT_APP_SAIL_PROBATE_DOMAIN_NAME || ""
    : p === "api" ? process.env.SAIL_PROBATE_DOMAIN_NAME || ""
    : requireExhaustive(p);

export const getPublicPortSuffix = (p: T): string => {
    const port =
        p === "web" ? (typeof window === "undefined" ? env.REACT_APP_PUBLIC_HTTPS_PORT : window.location.port)
        : p === "api" ? process.env.PUBLIC_HTTPS_PORT
        : requireExhaustive(p);
    return !port || port === "443" ? "" : `:${port}`;
};

export const envPortRewriteScript = `
(function () {
    var port = location.port;
    if (!port || port === "443") { return; }
    env.REACT_APP_PUBLIC_HTTPS_PORT = port;
    ["REACT_APP_API_URL", "REACT_APP_AUTH_URL", "REACT_APP_CRM_URL", "REACT_APP_HOME_URL"].forEach(function (key) {
        if (typeof env[key] === "string") {
            env[key] = env[key].replace(/^(https?:\\/\\/[^\\/:]+)(:\\d+)?/, "$1:" + port);
        }
    });
})();
`;

export const getCrmLinkFromHostnameAndEnv = (p: T, hostname: string): string => {
    if ( hostname.endsWith(getDomainNameFromEnv(p)) ) {
        return `https://listings.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return `https://portal.${getSailLegalDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.startsWith("quotes.sailprobate") && hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return `https://quotes.${getSailProbateDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.startsWith("quotes.saillegal") && hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return `https://quotes.${getSailLegalDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return `https://app.${getSailProbateDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else {
        return `https://listings.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
}

export const getAuthLinkFromHostnameAndEnv = (p: T, hostname: string): string => {
    if ( hostname.endsWith(getDomainNameFromEnv(p)) ) {
        return `https://auth.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return `https://auth.${getSailLegalDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return `https://auth.${getSailProbateDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else {
        return `https://auth.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
}

export const getApiLinkFromHostnameAndEnv = (p: T, hostname: string): string => {
    if ( hostname.endsWith(getDomainNameFromEnv(p)) ) {
        return `https://api.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return `https://api.${getSailLegalDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return `https://api.${getSailProbateDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else {
        return `https://api.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
}

export const getWebsocketsEndpointFromHostnameAndEnv = (p: T, hostname: string): string => {
    if ( hostname.endsWith(getDomainNameFromEnv(p)) ) {
        return `wss://api.${getDomainNameFromEnv(p)}:7071`;
    }
    else if (hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return `wss://api.${getSailLegalDomainNameFromEnv(p)}:7071`;
    }
    else if (hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return `wss://api.${getSailProbateDomainNameFromEnv(p)}:7071`;
    }
    else {
        return `wss://api.${getDomainNameFromEnv(p)}:7071`;
    }
}

export const getHomeLinkFromHostnameAndEnv = (p: T, hostname: string): string => {
    if ( hostname.endsWith(getDomainNameFromEnv(p)) ) {
        return `https://www.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return `https://www.${getSailLegalDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else if (hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return `https://www.${getSailProbateDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
    else {
        return `https://www.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}`;
    }
}

export const getAtEmailPartFromHostnameAndEnv = (p: T, hostname: string): string => {
    if ( hostname.endsWith(getDomainNameFromEnv(p)) ) {
        return `@${getDomainNameFromEnv(p)}`;
    }
    else if (hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return `@${getSailLegalDomainNameFromEnv(p)}`;
    }
    else if (hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return `@${getSailProbateDomainNameFromEnv(p)}`;
    }
    else {
        return `@${getDomainNameFromEnv(p)}`;
    }
}

export type envCurrentBrand = "sailhomes" | "saillegal" | "sailprobate";

export const getCurrentBrandHostnameAndEnv = (p: T, hostname: string): envCurrentBrand => {
    if ( hostname.endsWith(getDomainNameFromEnv(p)) ) {
        return "sailhomes";
    }
    else if (hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return "saillegal";
    }
    else if (hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return "sailprobate";
    }
    else {
        return "sailhomes";
    }
}

export type TBrandPrefix = "sl" | "sh" | "sp";

export const getCurrentBrandPrefix = (p: T, hostname: string): TBrandPrefix => {
    let envName = getCurrentBrandHostnameAndEnv(p, hostname);
    if (envName === "sailhomes") {
        return "sh"
    }
    else if (envName === "saillegal") {
        return "sl"
    }
    return "sp";
}

export const getCompanyNameForCurrentBrand = (p: T, hostname: string) => {
    let envName = getCurrentBrandHostnameAndEnv(p, hostname);
    if (envName === "sailhomes") {
        return "sail_homes";
    }
    else if (envName === "saillegal") {
        return "sail_legal";
    }
    return "sail_probate";
}

type envCurrentBrandTitle = "Sail Homes" | "Sail Legal" | "Sail Probate";

export const getCurrentBrandTitleHostnameAndEnv = (p: T, hostname: string): envCurrentBrandTitle => {
    if ( hostname.endsWith(getDomainNameFromEnv(p)) ) {
        return "Sail Homes";
    }
    else if (hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return "Sail Legal";
    }
    else if (hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return "Sail Probate";
    }
    else {
        return "Sail Homes";
    }
}

export const getFavIconUrlHostnameAndEnv = (p: T, hostname: string): string => {
    if ( hostname.endsWith(getDomainNameFromEnv(p)) ) {
        return `https://listings.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}/static/favicons/Sail_Homes_Favicon_256.png`;
    }
    else if (hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return `https://portal.${getSailLegalDomainNameFromEnv(p)}${getPublicPortSuffix(p)}/static/favicons/Sail_Legal_Favicon_256.png`;
    }
    else if (hostname.startsWith("quotes.sailprobate") && hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return `https://quotes.${getSailProbateDomainNameFromEnv(p)}${getPublicPortSuffix(p)}/static/favicons/Sail_Probate_Favicon_256.png`;
    }
    else if (hostname.startsWith("quotes.saillegal") && hostname.endsWith(getSailLegalDomainNameFromEnv(p)) ) {
        return `https://quotes.${getSailLegalDomainNameFromEnv(p)}${getPublicPortSuffix(p)}/static/favicons/Sail_Legal_Favicon_256.png`;
    }
    else if (hostname.endsWith(getSailProbateDomainNameFromEnv(p)) ) {
        return `https://app.${getSailProbateDomainNameFromEnv(p)}${getPublicPortSuffix(p)}/static/favicons/Sail_Probate_Favicon_256.png`;
    }
    else {
        return `https://listings.${getDomainNameFromEnv(p)}${getPublicPortSuffix(p)}/static/favicons/Sail_Homes_Favicon_256.png`;
    }
}